<template>
  <div :class="{ 'tw:mb-5': subtext }">
    <div class="tw:flex tw:flex-col tw:items-start tw:gap-y-1">
      <img v-if="logo" class="tw:h-[23px]" :src="logo" :alt="productName" />
      <h2 class="tw:text-2xl tw:font-bold">{{ title }}</h2>
      <p class="tw:text-sm">{{ subtext }}</p>
    </div>
  </div>
</template>
<script setup>
defineProps({
  logo: [String, Object],
  productName: String,
  title: String,
  subtext: String,
})
</script>
